module.exports = __webpack_public_path__ + "static/media/marchingInPlace.8509e9dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/fppExercises/marchingInPlace.png
// module id = 2545
// module chunks = 0